import { createContext, useContext, type FC, type ReactNode } from 'react';

type PageAccessContextValue = {
  /** Call after resolving resume target URL so prior steps match ticket "navigate back without losing access". */
  afterResumeNavigateTo: (targetPath: string) => void;
};

const PageAccessContext = createContext<PageAccessContextValue | null>(null);

export const PageAccessProvider: FC<{
  value: PageAccessContextValue;
  children: ReactNode;
}> = ({ value, children }) => <PageAccessContext.Provider value={value}>{children}</PageAccessContext.Provider>;

export function useResumePageAccess(): PageAccessContextValue | null {
  return useContext(PageAccessContext);
}
